import { render, staticRenderFns } from "./PageWorldNews.vue?vue&type=template&id=3e57b4ed&scoped=true&"
import script from "./PageWorldNews.vue?vue&type=script&lang=js&"
export * from "./PageWorldNews.vue?vue&type=script&lang=js&"
import style0 from "./PageWorldNews.vue?vue&type=style&index=0&id=3e57b4ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e57b4ed",
  null
  
)

export default component.exports